// extracted by mini-css-extract-plugin
export default {"container":"layout_container__Iz5wn","main":"layout_main__x19xl","conatiner":"layout_conatiner__xqTPU","outletDiv":"layout_outletDiv__z1rbF"};